/**
 * URLs for the teacher dashboard. Every tab and every open session/review/
 * subject has its own path, so the browser Back button steps back one page
 * inside the dashboard instead of leaving it for the login page.
 *
 *   /teacher/studio                       Content Studio home
 *   /teacher/studio/session/:draftId      a session open in the editor
 *   /teacher/studio/review/:inboxItemId   Auto Sync review before generation
 *   /teacher/studio/subject/:subjectId    one subject's sessions
 *   /teacher/<hub|classes|substitution|published|settings>
 */
export const TEACHER_SECTIONS = ['studio', 'hub', 'classes', 'substitution', 'published', 'settings'];

const STUDIO_PAGES = { session: 'draftId', review: 'reviewId', subject: 'subjectId' };
const BASE = '/teacher';

/** @returns {{ section: string, draftId?: string, reviewId?: string, subjectId?: string }} */
export function parseTeacherPath(pathname) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (parts[0] !== 'teacher') return { section: 'studio' };
  const section = TEACHER_SECTIONS.includes(parts[1]) ? parts[1] : 'studio';
  const key = section === 'studio' ? STUDIO_PAGES[parts[2]] : null;
  if (key && parts[3]) return { section, [key]: decodeURIComponent(parts[3]) };
  return { section };
}

export const teacherPath = {
  section: (id) => `${BASE}/${id}`,
  session: (draftId) => `${BASE}/studio/session/${encodeURIComponent(draftId)}`,
  review: (itemId) => `${BASE}/studio/review/${encodeURIComponent(itemId)}`,
  subject: (subjectId) => `${BASE}/studio/subject/${encodeURIComponent(subjectId)}`,
};
